import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import CustomerModel from 'cio/models/customer';
import IndexController from 'cio/pods/person/index/controller';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';

export default class IndexRoute extends Route {
  @service features!: FeaturesService;

  activate() {
    (this.modelFor('person') as CustomerModel).hasMany('segments').reload();
  }

  setupController(controller: IndexController, model: CustomerModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchLogs.perform();
    controller.fetchDeliveries.perform();
  }

  deactivate() {
    super.deactivate();

    (this.controller as IndexController).set('searchTerm', '');
  }
}
